import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isBefore(dateString: string) {
  const today = new Date();
  const targetDate = new Date(dateString);

  // Compare the two dates
  return today < targetDate;
}

/**
 * Get the organization ID from context, with fallback to localStorage.
 * This is needed because during rapid navigation after onboarding,
 * the router context may not have been updated yet due to async state updates.
 */
export function getOrgIdWithFallback(contextOrgId: string | undefined): string {
  if (contextOrgId) {
    return contextOrgId;
  }

  try {
    const currentOrg = window.localStorage.getItem("current_org");
    if (currentOrg) {
      return (JSON.parse(currentOrg) as { orgId: string }).orgId;
    }
  } catch (e) {
    console.warn("Failed to read orgId from localStorage:", e);
  }

  return "";
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
